import * as React from 'react';
import { Header, Segment } from 'semantic-ui-react';

export interface Props {
    /** Título del panel */
    titulo: string;

    /** Color del título del panel */
    color?: string;

    /** Determina si el panel, junto a su contenido, estará oculto */
    oculto?: boolean;
}

/**
 * Representa un panel, con título y contenido.
 *
 * El panel se presenta usando un Segment.Group de semantic-ui.
 */
const Panel: React.FunctionComponent<Props> = props => {
    const { titulo, color, oculto = false, children } = props;

    return (
        <Segment.Group hidden={oculto}>
            <Segment inverted={color ? true : false} style={{ backgroundColor: color }}>
                <Header>{titulo}</Header>
            </Segment>
            <Segment>{children}</Segment>
        </Segment.Group>
    );
};

export default Panel;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Panel.tsx